import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "q-pt-md q-pb-sm q-pl-md overflow-auto" }
const _hoisted_2 = {
  "data-test": "equipment-model-name",
  class: "equipment float-bottom title"
}
const _hoisted_3 = {
  "data-test": "equipment-model-description",
  class: "equipment text-h6 float-bottom subtitle q-ml-sm"
}
const _hoisted_4 = {
  key: 0,
  "data-test": "equipment-avg-avl",
  class: "float-right",
  style: {"text-align":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Avg Avl: ", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Avg Rel: ", -1 /* HOISTED */)
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_AggregateGraph = _resolveComponent("AggregateGraph")!
  const _component_EquipmentTag = _resolveComponent("EquipmentTag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.modelName), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.description), 1 /* TEXT */),
      (_ctx.getReportingView === _ctx.ReportingViewType.BARCHART)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, [
              _createVNode(_component_q_chip, {
                square: "",
                icon: _ctx.icon,
                class: _normalizeClass(_ctx.getClassQualityIconForGraph),
                label: _ctx.operatingPhilosophy,
                "text-color": "white"
              }, null, 8 /* PROPS */, ["icon", "class", "label"])
            ]),
            _createElementVNode("span", null, [
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.formatter(_ctx.availability)) + "% ", 1 /* TEXT */)
            ]),
            _createElementVNode("span", null, [
              _hoisted_6,
              _createTextVNode(_toDisplayString(_ctx.formatter(_ctx.reliability)) + "% ", 1 /* TEXT */)
            ]),
            _createVNode(_component_q_btn, {
              size: "md",
              "data-test": "emit-expension-button-model",
              flat: "",
              class: "red text-weight-bold",
              icon: _ctx.iconType,
              onClick: _ctx.emitExpensionButtonModel
            }, null, 8 /* PROPS */, ["icon", "onClick"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.getReportingView === _ctx.ReportingViewType.BARCHART)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_AggregateGraph, { "equipment-statistics": _ctx.equipmentStatistics }, null, 8 /* PROPS */, ["equipment-statistics"]),
          _withDirectives(_createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eqDescriptionEqs, (equipment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: equipment.id
              }, [
                _createVNode(_component_EquipmentTag, {
                  class: "q-ma-sm",
                  equipment: equipment,
                  "weekly-comments": true
                }, null, 8 /* PROPS */, ["equipment"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.iconType === 'expand_less']
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}